import React from "react"
import { useSelector } from "react-redux"

const useUser = () => {
	const userList = useSelector((state) => state.info.usersList)
	const { user } = useSelector((state) => state?.authtentication?.user)

	function getUserById(userId) {
		return userId ? userList?.find((user) => user.user_id === userId) : null
	}

	function getUserNameById(userId) {
		return userId ? userList?.find((user) => user.user_id === userId)?.username : "NA"
	}

	return {
		getUserById,
		getUserNameById,
		userList: userList,
		currentUser: user,
	}
}

export default useUser
